interface HubEmptyStateProps {
  title: string;
  description: string;
}

export function HubEmptyState({ title, description }: HubEmptyStateProps) {
  return (
    <div className="flex min-h-[300px] flex-col items-center justify-center py-12">
      <img
        src="/assets/scribble-orange.png"
        alt="Caught up"
        className="mb-4 h-28 w-28"
      />
      <div className="mb-2 text-lg font-bold text-primary">{title}</div>
      <div className="text-sm text-secondary">{description}</div>
    </div>
  );
}
